module.exports = __webpack_public_path__ + "img/Picture15.02dee905.png";